const mEditionMapChartPoints = {
  mEditionMapChartPoints: {

    messageAlertFamily: {
      firstText: 'Aún no existen integrantes para el equipo',
      secondText: 'Para agregar integrantes puedes acceder en Equipos'
    },

    messageAlertTeam: {
      firstText: 'Aún no existen equipos.'
    },

    messageAlertNoTeam: {
      firstText: 'Aún no existen alumnos sin equipos.'
    },

    messageLoading: {
      firstText: 'Cargando..'
    },

    select: {
      equipo: 'Todos los equipos'
    }
  }
}

export default mEditionMapChartPoints
